import { statusOptions } from "@src/pages/transactionsIn/constants"
import { CollectionFilters } from "@src/shared/componemts/TableFilter/classes/CollectionFilters"
import {
  filtersPresets,
  getFilterSimpleFiled,
} from "@src/shared/componemts/TableFilter/classes/constants"

export const TransactionsDepositsCollectionFilters = [
  {
    ...getFilterSimpleFiled("address").search({
      col: 6,
      label: "Address",
      placeholder: "Search by address",
    }),
  },
  {
    ...getFilterSimpleFiled("id").search({
      col: 6,
      label: "ID",
      placeholder: "Search by ID",
    }),
  },
  {
    ...getFilterSimpleFiled("depositId").search({
      col: 6,
      label: "Deposit ID",
      placeholder: "Search by Deposit ID",
    }),
  },
  {
    ...getFilterSimpleFiled("txId").search({
      col: 6,
      label: "Tx ID",
      placeholder: "Search by Tx ID",
    }),
  },
  { ...filtersPresets.order, col: 6 },
  { ...filtersPresets.status, col: 6 },
  {
    ...getFilterSimpleFiled("amlLevel").select(
      [
        { label: "High", value: "high" },
        { label: "Medium", value: "medium" },
        { label: "Low", value: "low" },
      ],
      {
        col: 6,
        label: "AML level",
        placeholder: "Select AML level",
      },
    ),
  },
]
